import React, { useState, useContext, useEffect, useMemo, useCallback, useRef } from "react";
import { useHistory } from "react-router-dom";

//pages & includes
import ManageSidebar from "../ManageSidebar";
import Select from "react-select";
//functions
import {
  _t,
  getCookie,
  modalLoading,
  customStyle,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//3rd party packages
import { Helmet } from "react-helmet";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MdDelete } from 'react-icons/md';
import Moment from "react-moment";


//context consumer
import { SettingsContext } from "../../../../../contexts/Settings";
import { FinanceContext } from "../../../../../contexts/Finance";
import { RestaurantContext } from "../../../../../contexts/Restaurant";
import DataTable from "../../../../common/DataTable";

const PaymentTypeCrud = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const searchInputRef = useRef(null);
  //getting context values here
  let {
    //common
    loading,
    setLoading,
  } = useContext(SettingsContext);

  const { cao3Active, coa3ForSearch, getCoaL3 } = useContext(FinanceContext);

  let {
    //paymentType
    paymentTypeList,
    setPaymentTypeList,
    setPaginatedPaymentType,
    paymentTypeForSearch,
    setPaymentTypeforSearch,
    //md accounts
    MdIntegrationForSearch,
    getMdIntegrationGroup,
    //pagination
    dataPaginating,
  } = useContext(RestaurantContext);

  // States hook here
  //new group
  let [newPaymentType, setNewPaymentType] = useState({
    name: "",
    input_key: "",
    account_map_id: null,
    prefix: "",
    payment_type:"cash",
    payment_type_comission: "",
    viewCard:false,
    card_payment: 0,
    customer_mandatory: 0,
    bank_required: 0,
    min_card_no: "",
    coa: null,
    edit: false,
    editSlug: null,
    uploading: false,
    color: "",
    displayColorPicker: false,
  });

  //search result
  let [searchedPaymentType, setSearchedPaymentType] = useState({
    list: null,
    searched: false,
  });

  //set name, input key hook
  const handleSetNewPaymentType = (e) => {
    setNewPaymentType({ ...newPaymentType, [e.target.name]: e.target.value });
  };

  const handleSetPayment = (payment) =>{
    setNewPaymentType({ ...newPaymentType, account_map_id: payment });
  }

  const handleViewCard = (e) =>{
    setNewPaymentType({...newPaymentType, viewCard: !newPaymentType.viewCard, min_card_no: newPaymentType.viewCard ? "" : 6})
  }

  const handleCardPayment = (e) =>{
    setNewPaymentType({...newPaymentType, [e.target.name]: newPaymentType.card_payment ? 0 : 1})
  }

  const handleCustomerMandatory = () => {
    setNewPaymentType({
      ...newPaymentType,
      customer_mandatory: newPaymentType.customer_mandatory ? 0 : 1,
    });
  };

  const handleBankMandatory = () => {
    setNewPaymentType({
      ...newPaymentType,
      bank_required: newPaymentType.bank_required ? 0 : 1,
    });
  };

  useEffect(()=>{
    if(!MdIntegrationForSearch){
      getMdIntegrationGroup();
    }
    if(!cao3Active){
      getCoaL3();
    }
  },[]);

  const handleSetSelect = (key,value)=>{
    setNewPaymentType((curr)=>({
      ...curr,
      [key]: value,
    }));
  }

  //Save New paymentType
  const handleSaveNewPaymentType = (e) => {
    e.preventDefault();
    setNewPaymentType({
      ...newPaymentType,
      uploading: true,
    });
    const account = newPaymentType.account_map_id ? newPaymentType.account_map_id.id : "";
    const paymentTypeUrl = BASE_URL + `/settings/new-payment-type`;
    let formData = new FormData();
    formData.append("name", newPaymentType.name);
    formData.append("input_key", newPaymentType.input_key);
    formData.append("payment_type", newPaymentType.payment_type);
    formData.append("payment_type_comission", newPaymentType.payment_type_comission);
    formData.append("prefix", newPaymentType.prefix);
    formData.append("account_map_id", account);
    formData.append("view_card", newPaymentType.viewCard === false ? 0 : 1);
    formData.append("card_payment", newPaymentType.card_payment);
    formData.append("customer_mandatory", newPaymentType.customer_mandatory ? 1 : 0);
    formData.append("bank_required", newPaymentType.bank_required ? 1 : 0);
    formData.append("digit_required", newPaymentType.min_card_no ?? 0);
    formData.append("payment_coa_id", newPaymentType.coa?.id ?? "");
    formData.append("payment_coa_name", newPaymentType.coa?.level3_name ?? "");
    formData.append("color", newPaymentType.color);

    return axios
      .post(paymentTypeUrl, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        if (res.data !== "A payment type already exists with this key") {
          setNewPaymentType({
            name: "",
            input_key: "",
            account_map_id: null,
            payment_type:"cash",
            payment_type_comission: "",
            viewCard: false,
            card_payment: 0,
            customer_mandatory: 0,
            bank_required: 0,
            coa: null,
            edit: false,
            editSlug: null,
            uploading: false,
            color: "#ffffff",
            displayColorPicker: false,
          });
          setPaymentTypeList(res.data[0]);
          setPaymentTypeforSearch(res.data[1]);
          setSearchedPaymentType({
            ...searchedPaymentType,
            list: res.data[1],
          });
          setLoading(false);
          toast.success(`${_t(t("Payment type has been added"))}`, {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
          document.getElementById('close-btn').click();
        } else {
          setLoading(false);
          setNewPaymentType({
            ...newPaymentType,
            uploading: false,
          });
          toast.error(
            `${_t(t("A payment type already exists with this key"))}`,
            {
              position: "bottom-center",
              autoClose: 10000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              className: "text-center toast-notification",
            }
          );
        }
      })
      .catch(() => {
        setLoading(false);
        setNewPaymentType({
          ...newPaymentType,
          uploading: false,
        });
        toast.error(`${_t(t("Please try again"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      });
  };

  //set edit true & values
  const handleSetEdit = (item) => {
    let paymentType = item;
    // paymentTypeForSearch.find((item) => {
    //   return item.slug === slug;
    // });

    const account_map_id = paymentType?.account_map_id
      ? (MdIntegrationForSearch || []).find((item) => item.id === paymentType.account_map_id) || null
      : null;
    const coa = paymentType?.payment_coa_id
      ? (coa3ForSearch || []).find((coa) => coa.id === paymentType.payment_coa_id) || ""
      : "";
    
    setNewPaymentType({
      ...newPaymentType,
      name: paymentType.name,
      input_key: paymentType.input_key,
      prefix: paymentType.prefix,
      payment_type: paymentType.payment_type,
      payment_type_comission: paymentType.payment_type_comission,
      account_map_id: account_map_id,
      coa,
      viewCard: paymentType.view_card == 1 ? true : false,
      card_payment : paymentType.card_payment,
      customer_mandatory: Number(paymentType.customer_mandatory) === 1 ? 1 : 0,
      bank_required: Number(paymentType.bank_required) === 1 ? 1 : 0,
      min_card_no: paymentType.digit_required ?? "",
      editSlug: paymentType.slug,
      edit: true,
      color: paymentType.color || "",
      displayColorPicker: false,
    });
  };

  //update payment Type
  const handleUpdatePaymentType = (e) => {
    e.preventDefault();
    setNewPaymentType({
      ...newPaymentType,
      uploading: true,
    });
    const account = newPaymentType.account_map_id ? newPaymentType.account_map_id.id : "";
    const paymentTypeUrl = BASE_URL + `/settings/update-payment-type`;
    let formData = new FormData();
    formData.append("name", newPaymentType.name);
    formData.append("account_map_id", account);
    formData.append("payment_type", newPaymentType.payment_type);
    formData.append("payment_type_comission", newPaymentType.payment_type_comission);
    formData.append("prefix", newPaymentType.prefix);
    formData.append("editSlug", newPaymentType.editSlug);
    formData.append("view_card", newPaymentType.viewCard === false ? 0 : 1);
    formData.append("card_payment", newPaymentType.card_payment);
    formData.append("customer_mandatory", newPaymentType.customer_mandatory ? 1 : 0);
    formData.append("bank_required", newPaymentType.bank_required ? 1 : 0);
    formData.append("digit_required", newPaymentType.min_card_no ?? 0);
    formData.append("payment_coa_id", newPaymentType.coa?.id ?? "");
    formData.append("payment_coa_name", newPaymentType.coa?.level3_name ?? "");
    formData.append("color", newPaymentType.color);

    return axios
      .post(paymentTypeUrl, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setNewPaymentType({
          name: "",
          input_key: "",
          account_map_id: null,
          payment_type:"cash",
          payment_type_comission: "",
          viewCard: false,
          card_payment: 0,
          customer_mandatory: 0,
          bank_required: 0,
          coa: null,
          edit: false,
          editSlug: null,
          uploading: false,
          color: "",
          displayColorPicker: false,
        });
        setPaymentTypeList(res.data[0]);
        setPaymentTypeforSearch(res.data[1]);
        setSearchedPaymentType({
          ...searchedPaymentType,
          list: res.data[1],
        });
        setLoading(false);
        toast.success(`${_t(t("Payment type has been updated"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        document.getElementById('close-btn').click();
      })
      .catch(() => {
        setLoading(false);
        setNewPaymentType({
          ...newPaymentType,
          uploading: false,
        });
        toast.error(`${_t(t("Please try again"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      });
  };

  //search payment Type here
  const handleSearch = (e) => {
    let searchInput = e.target.value.toLowerCase();
    if (searchInput.length === 0) {
      setSearchedPaymentType({ ...searchedPaymentType, searched: false });
    } else {
      let searchedList = (paymentTypeForSearch || []).filter((item) => {
        let lowerCaseItemName = item.name?.toLowerCase();
        let lowerCaseItemInputKey = item.input_key?.toLowerCase();
        return (
          (lowerCaseItemName && lowerCaseItemName.includes(searchInput)) ||
          (lowerCaseItemInputKey && lowerCaseItemInputKey.includes(searchInput))
        );
      });
      setSearchedPaymentType({
        ...searchedPaymentType,
        list: searchedList,
        searched: true,
      });
    }
  };

  const handleFetchData = (page) => {
    setPaginatedPaymentType(page);
  };

  const onClearSearch = () => {
    setSearchedPaymentType({ ...searchedPaymentType, searched: false });
    if (searchInputRef.current) {
      searchInputRef.current.value = "";
    }
  };

  const getListData = useCallback(() => {
    if (searchedPaymentType.searched) {
      return searchedPaymentType.list || [];
    }
    return paymentTypeList?.data || [];
  }, [searchedPaymentType, paymentTypeList]);

  //delete confirmation modal of paymentType
  const handleDeleteConfirmation = (slug) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="card card-body">
            <h1>{_t(t("Are you sure?"))}</h1>
            <p className="text-center">{_t(t("You want to delete this?"))}</p>
            <div className="d-flex justify-content-center">
              <button
                className="btn btn-primary"
                onClick={() => {
                  handleDeletePaymentType(slug);
                  onClose();
                }}
              >
                {_t(t("Yes, delete it!"))}
              </button>
              <button className="btn btn-success ml-2 px-3" onClick={onClose}>
                {_t(t("No"))}
              </button>
            </div>
          </div>
        );
      },
    });
  };

  //delete paymentType here
  const handleDeletePaymentType = (slug) => {
    setLoading(true);
    const paymentTypeUrl = BASE_URL + `/settings/delete-payment-type/${slug}`;
    return axios
      .get(paymentTypeUrl, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setPaymentTypeList(res.data[0]);
        setPaymentTypeforSearch(res.data[1]);
        setSearchedPaymentType({
          ...searchedPaymentType,
          list: res.data[1],
        });
        setLoading(false);
        toast.success(
          `${_t(t("Payment type has been deleted successfully"))}`,
          {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          }
        );
      })
      .catch(() => {
        setLoading(false);
        toast.error(`${_t(t("Please try again"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      });
  };

  const columns = useMemo(
    () => [
      {
        label: _t(t("S/L")),
        render: (_item, index) =>
          searchedPaymentType.searched
            ? index + 1
            : index +
              1 +
              ((paymentTypeList?.current_page || 1) - 1) *
                (paymentTypeList?.per_page || 0),
      },
      {
        label: _t(t("Name")),
        key: "name",
      },
      {
        label: _t(t("Unique Key")),
        key: "input_key",
      },
      {
        label: _t(t("Action")),
        render: (item) => (
          <div className="d-flex justify-content-center">
            <button
              className="btn btn-primary ml-2 rounded-sm del-btn"
              onClick={() => handleSetEdit(item)}
              data-toggle="modal"
              data-target="#addPaymentType"
            >
              <i className="fa fa-pencil edit-icon" aria-hidden="true"></i>
            </button>
            <button
              className="btn btn-danger ml-2 rounded-sm del-btn"
              onClick={() => handleDeleteConfirmation(item.slug)}
            >
              <MdDelete className="del-icon" />
            </button>
          </div>
        ),
      },
      {
        label: _t(t("Updated")),
        render: (item) =>
          item?.updated_at ? (
            <Moment format="LL">{item.updated_at}</Moment>
          ) : (
            ""
          ),
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [t, searchedPaymentType.searched, paymentTypeList?.current_page, paymentTypeList?.per_page]
  );

  const handleChangeColor = (color) => {
    setNewPaymentType({ ...newPaymentType, color: color.hex });
  };

  return (
    <>
      <Helmet>
        <title>{_t(t("Payment Types"))}</title>
      </Helmet>

      {/* Add modal */}
      <div className="modal fade" id="addPaymentType" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header align-items-center">
              <div className="fk-sm-card__content">
                <h5 className="text-capitalize fk-sm-card__title">
                  {!newPaymentType.edit
                    ? _t(t("Add new payment type"))
                    : _t(t("Update payment type"))}
                </h5>
              </div>
              <button
                type="button"
                id="close-btn"
                className="btn-close"
                data-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              {/* show form or show saving loading */}
              {newPaymentType.uploading === false ? (
                <div key="fragment-payment-type-1">
                  <form
                    onSubmit={
                      !newPaymentType.edit
                        ? handleSaveNewPaymentType
                        : handleUpdatePaymentType
                    }
                    autoComplete="off"
                  >
                    <div>
                      <label htmlFor="name" className="form-label">
                        {_t(t("Name"))}{" "}
                        <small className="text-danger">*</small>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        name="name"
                        placeholder="e.g. Cash"
                        value={newPaymentType.name || ""}
                        required
                        onChange={handleSetNewPaymentType}
                      />
                    </div>

                    <div className="row mt-3">
                      <div className="col-6">
                        <label htmlFor="prefix" className="form-label">
                          {_t(t("Prefix"))}
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="prefix"
                          name="prefix"
                          placeholder="e.g. cash, card"
                          value={newPaymentType.prefix || ""}
                          onChange={handleSetNewPaymentType}
                        />
                      </div>
                      <div className="col-6">
                        <label className="form-label">
                          {_t(t("Pick Color"))}
                        </label>
                        <label className="w-100 m-0" style={{ cursor: "pointer" }}>
                          <div
                            style={{
                              height: "38px",
                              backgroundColor: newPaymentType.color || "transparent",
                            }}
                            className="form-control w-100"
                          />
                          <input
                            type="color"
                            style={{ opacity: 0, width: 0, height: 0, position: "absolute" }}
                            value={newPaymentType.color || "#ffffff"}
                            onChange={(e) => handleChangeColor({ hex: e.target.value })}
                          />
                        </label>
                      </div>
                    </div>

                    <div className="mt-3">
                      <label htmlFor="input_key" className="form-label">
                        {_t(t("Unique Key"))}{" "}
                        <small className="text-danger">*</small>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="input_key"
                        name="input_key"
                        placeholder="e.g. 'cash-payment' for 'Cash'"
                        value={newPaymentType.input_key || ""}
                        required={!newPaymentType.edit}
                        onChange={handleSetNewPaymentType}
                        disabled={newPaymentType.edit}
                      />
                    </div>

                    <div className="row">
                      <div className="mt-3 col-6">
                        <label htmlFor="input_key" className="form-label">
                          {_t(t("Payment Account Link"))}{" "}
                        </label>
                        <Select
                          options={MdIntegrationForSearch ? MdIntegrationForSearch : []}
                          getOptionLabel={(option) => option.account_name}
                          getOptionValue={(option) => option.id}
                          classNamePrefix="select"
                          onChange={(e)=>handleSetPayment(e)}
                          value={newPaymentType.account_map_id}
                          isClearable
                          styles={customStyle}
                          placeholder={
                          _t(t("Please select type")) + ".."
                          }                                                
                        />
                      </div>
                      <div className="mt-3 col-6">
                        <label htmlFor="_unit" className="form-label mb-1">
                          {_t(t("Account"))}
                        </label>
                        <Select
                          options={cao3Active ?? []}
                          value={newPaymentType.coa}
                          getOptionLabel={(option) => option.level3_name}
                          getOptionValue={(option) => option.id}
                          classNamePrefix="select"
                          isClearable
                          onChange={(coa) => handleSetSelect("coa", coa)}
                          maxMenuHeight="200px"
                          styles={customStyle}
                          placeholder={
                            _t(t("Please select coa")) + ".."
                          }
                        />
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col-6">
                        <label htmlFor="" className="form-label">
                          {_t(t("Payment Type"))}{" "}
                          <small className="text-danger">*</small>
                        </label>
                        <div>
                          <input
                            type="radio"
                            className="form-check-input pointer-cursor"
                            id="cash"
                            name="payment_type"
                            value="cash"
                            onChange={(e) => {
                              handleSetNewPaymentType(e);
                            }}
                            checked={newPaymentType.payment_type === "cash"}
                          />
                          <label htmlFor="cash" className="form-label ml-1 mr-3">
                            {_t(t("Cash"))}
                          </label>
                          <input
                            type="radio"
                            className="form-check-input pointer-cursor"
                            id="card"
                            name="payment_type"
                            value="card"
                            onChange={(e) => {
                              handleSetNewPaymentType(e);
                            }}
                            checked={newPaymentType.payment_type === "card"}
                          />
                          <label htmlFor="card" className="form-label ml-1">
                            {_t(t("Card"))}
                          </label>
                        </div>
                      </div>
                      <div className="col-6">
                        <label htmlFor="payment_type_comission" className="form-label">
                          {_t(t("Party Type Commission"))}{" "}
                        </label>
                        <input
                          type="number"
                          step={0.01}
                          onKeyDown={(evt) =>
                            ["e", "E", "+", "-","ArrowUp","ArrowDown",].includes(evt.key) &&
                            evt.preventDefault()
                          }
                          className="form-control"
                          id="payment_type_comission"
                          name="payment_type_comission"
                          placeholder="e.g 0.1"
                          value={newPaymentType.payment_type_comission || ""}
                          onChange={handleSetNewPaymentType}
                        />
                      </div>
                    </div> 

                    <div className="row align-items-center mt-3">
                      <div className="col-auto">
                        <div className="form-check d-flex align-items-center mb-0">
                          <input
                            type="checkbox"
                            className="form-check-input mt-0"
                            id="card_payment"
                            name="card_payment"
                            value={1}
                            checked={!!newPaymentType.card_payment}
                            onChange={handleCardPayment}
                          />
                          <label
                            className="form-check-label ml-2 mb-0"
                            htmlFor="card_payment"
                          >
                            {_t(t("Card Payment?"))}
                          </label>
                        </div>
                      </div>
                      <div className="col-auto">
                        <div className="form-check d-flex align-items-center mb-0">
                          <input
                            type="checkbox"
                            className="form-check-input mt-0"
                            id="customer_mandatory"
                            name="customer_mandatory"
                            value={1}
                            checked={Number(newPaymentType.customer_mandatory) === 1}
                            onChange={handleCustomerMandatory}
                          />
                          <label
                            className="form-check-label ml-2 mb-0"
                            htmlFor="customer_mandatory"
                          >
                            {_t(t("Customer Mandatory"))}
                          </label>
                        </div>
                      </div>
                      <div className="col-auto">
                        <div className="form-check d-flex align-items-center mb-0">
                          <input
                            type="checkbox"
                            className="form-check-input mt-0"
                            id="bank_required"
                            name="bank_required"
                            value={1}
                            checked={Number(newPaymentType.bank_required) === 1}
                            onChange={handleBankMandatory}
                          />
                          <label
                            className="form-check-label ml-2 mb-0"
                            htmlFor="bank_required"
                          >
                            {_t(t("Bank Required"))}
                          </label>
                        </div>
                      </div>
                      <div className="col-auto">
                        <div className="form-check d-flex align-items-center mb-0">
                          <input
                            type="checkbox"
                            className="form-check-input mt-0"
                            id="addCard"
                            checked={newPaymentType.viewCard}
                            onChange={handleViewCard}
                          />
                          <label
                            className="form-check-label ml-2 mb-0"
                            htmlFor="addCard"
                          >
                            {_t(t("Add Card No?"))}
                          </label>
                        </div>
                      </div>
                      {newPaymentType.viewCard && (
                        <div className="col-auto d-flex align-items-center">
                          <label
                            className="form-check-label mr-2 mb-0"
                            htmlFor="min_card"
                          >
                            {_t(t("Min Card No"))}
                          </label>
                          <input
                            type="number"
                            className="form-control px-2"
                            style={{ width: "80px" }}
                            id="min_card"
                            name="min_card_no"
                            value={newPaymentType.min_card_no}
                            onChange={handleSetNewPaymentType}
                          />
                        </div>
                      )}
                    </div> 

                    <div className="mt-4">
                      <div className="row d-flex justify-content-end align-items-center">
                        <div className="col-3">
                          <button
                            type="submit"
                            className="btn btn-success w-100 xsm-text text-uppercase t-width-max rounded"
                          >
                            {!newPaymentType.edit
                              ? _t(t("Save"))
                              : _t(t("Update"))}
                          </button>
                        </div>
                        <div className="col-3">
                          <button
                            type="button"
                            className="btn btn-primary w-100 xsm-text text-uppercase t-width-max rounded"
                            data-dismiss="modal"
                          >
                            {_t(t("Close"))}
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              ) : (
                <div key="fragment2">
                  <div className="text-center text-primary font-weight-bold text-uppercase">
                    {_t(t("Please wait"))}
                  </div>
                  {modalLoading(3)}
                  <div className="mt-4">
                    <div className="row d-flex justify-content-end align-items-center">
                      <div className="col-3">
                        <button
                          type="button"
                          className="btn btn-success w-100 xsm-text text-uppercase t-width-max rounded"
                          onClick={(e) => {
                            e.preventDefault();
                          }}
                        >
                          {!newPaymentType.edit
                            ? _t(t("Save"))
                            : _t(t("Update"))}
                        </button>
                      </div>
                      <div className="col-3">
                        <button
                          type="button"
                          className="btn btn-primary w-100 xsm-text text-uppercase t-width-max rounded"
                          data-dismiss="modal"
                        >
                          {_t(t("Close"))}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* Add modal Ends*/}

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ManageSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div className="t-pl-15 t-pr-15">
                  <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                    <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                      <ul className="t-list fk-breadcrumb">
                        <li className="fk-breadcrumb__list">
                          <span className="t-link fk-breadcrumb__link text-capitalize">
                            {t("Payment Type List")}
                          </span>
                        </li>
                      </ul>
                    </div>
                    <div className="col-md-6 col-lg-7">
                      <div className="row gx-3 align-items-center">
                        {/* Search group */}
                        <div className="col-md-9 t-mb-15 mb-md-0">
                          <div className="input-group">
                            <div className="form-file">
                              <input
                                type="text"
                                className="form-control border-0 form-control--light-1 rounded-left"
                                placeholder={_t(t("Search")) + ".."}
                                onChange={handleSearch}
                                ref={searchInputRef}
                              />
                            </div>
                            <button
                              className="btn btn-primary rounded-right"
                              type="button"
                            >
                              <i
                                className="fa fa-search"
                                aria-hidden="true"
                              ></i>
                            </button>
                          </div>
                        </div>

                        {/* Add group modal trigger button */}
                        <div className="col-md-3 text-md-right">
                          <button
                            type="button"
                            className="btn btn-primary xsm-text text-uppercase btn-lg btn-block rounded"
                            data-toggle="modal"
                            data-target="#addPaymentType"
                            onClick={() => {
                              setNewPaymentType({
                                ...newPaymentType,
                                name: "",
                                input_key: "",
                                payment_type: "cash",
                                payment_type_comission: "",
                                account_map_id: null,
                                viewCard: false,
                                card_payment: 0,
                                customer_mandatory: 0,
                                bank_required: 0,
                                edit: false,
                                editSlug: null,
                                uploading: false,
                              });
                            }}
                          >
                            {_t(t("add new"))}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <DataTable
                  loading={loading || dataPaginating}
                  data={getListData()}
                  columns={columns}
                  emptyText="No data available"
                  pagination={{
                    isPageLoading: dataPaginating,
                    isPagination: true,
                    pageCount: paymentTypeList?.last_page,
                    currentPage: paymentTypeList?.current_page,
                    from: paymentTypeList?.from,
                    to: paymentTypeList?.to,
                    total: paymentTypeList?.total,
                  }}
                  handleFetchData={handleFetchData}
                  searchPayload={{
                    isSearched: searchedPaymentType.searched,
                    onClearSearch,
                  }}
                />
              </div>
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
      {/* main body ends */}
    </>
  );
};

export default PaymentTypeCrud;